import { gql } from '@apollo/client';
import {
  AbAddressMappingPageResponse,
  AbAddressMappingType,
} from '../../../wms/abAddress/graphql/abAddressGraphql';

export type { AbAddressMappingType, AbAddressMappingPageResponse };

export interface GetAbAddressReviewListingResponse {
  getAbAddressReviewListing: AbAddressMappingPageResponse;
}

export interface ReviewAbAddressMappingResponse {
  reviewAbAddressMapping: AbAddressMappingType;
}

export interface ReviewAbAddressMappingInput {
  id: number;
  approved: boolean;
  reviewNote?: string;
}

const AB_ADDRESS_REVIEW_FIELDS = `
  id
  hubId
  hubName
  aFullAddress
  bFullAddress
  reason
  reporterAccountId
  reporterName
  reviewStatus
  reviewNote
  reviewerName
  reviewedAt
  createdAt
  updatedAt
`;

export const GET_AB_ADDRESS_REVIEW_LISTING = gql`
  query GetAbAddressReviewListing(
    $hubId: Long
    $id: Long
    $aAddress: String
    $bAddress: String
    $reporterName: String
    $status: Int
    $page: Int!
    $size: Int!
  ) {
    getAbAddressReviewListing(
      hubId: $hubId
      id: $id
      aAddress: $aAddress
      bAddress: $bAddress
      reporterName: $reporterName
      status: $status
      page: $page
      size: $size
    ) {
      content {
        ${AB_ADDRESS_REVIEW_FIELDS}
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const REVIEW_AB_ADDRESS_MAPPING = gql`
  mutation ReviewAbAddressMapping($input: ReviewAbAddressMappingInput!) {
    reviewAbAddressMapping(input: $input) {
      ${AB_ADDRESS_REVIEW_FIELDS}
    }
  }
`;
